import { ResenjeZaPlacenoOdsustvo } from './resenje-za-placeno-odsustvo';
import { BaseDataService, NotificationService, QueryParameter } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
import { FormGroup, Validators } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
import { NgbDate, NgbPeriod } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateRange } from 'yt-ng-framework/lib/base-models/date-range';
import { RadniDani } from 'src/app/kad.bl/radni-dani/radni-dani';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-resenje-za-placeno-odsustvo-update',
  templateUrl: './resenje-za-placeno-odsustvo-update.component.html'
})
export class ResenjeZaPlacenoOdsustvoUpdateComponent
extends BaseUpdateComponent<ResenjeZaPlacenoOdsustvo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('OsobaID', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.OSOBA.VALIDATION.REQUIRED');
    this.addValidatorToFc('OsnovID', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.OSNOV.VALIDATION.REQUIRED');
    this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED')
    this.addValidatorToFc('BrojDokumenta', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.BROJDOKUMENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datum', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.DATUM.VALIDATION.REQUIRED');
    // this.addValidatorToFc('OdDatuma', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.ODDATUMA.VALIDATION.REQUIRED');
    // this.addValidatorToFc('DoDatuma', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.DODATUMA.VALIDATION.REQUIRED');
    // this.addValidatorToFc('Period', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.PERIOD.VALIDATION.REQUIRED');
    this.addValidatorToFc('Dana', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.DANA.VALIDATION.REQUIRED');
    this.addValidatorToFc('DatumPocetkaRada', Validators.required, 'required', 'RESENJEZAPLACENOODSUSTVO.DATUMPOCETKARADA.VALIDATION.REQUIRED');



    this.IDProcessed
    .subscribe((value) => {
        if (value && this.Item.ID == -1) {
    let dateNow = new Date();
    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
    let pp: DateRange ={FromDate: date, ToDate:date};

    this.baseFormGroup.patchValue({ Period: pp });
    this.baseFormGroup.patchValue({ Datum: date });
    this.baseFormGroup.get('Period').updateValueAndValidity();
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    this.baseFormGroup.get('BrojDokumenta').enable();
    this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
    this.baseFormGroup.get('Datum').enable();
    this.baseFormGroup.get('Datum').updateValueAndValidity();



        }else{
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        this.baseFormGroup.get('BrojDokumenta').disable();
        this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
        // this.baseFormGroup.get('Datum').disable();
        // this.baseFormGroup.get('Datum').updateValueAndValidity();
       }
    })


  }

  onPodVrstaSelect(){
    this.getBrojDokumenta();
  }

  getBrojDokumenta(){
    let podvrstaid= this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
    let datum = this.baseFormGroup.get('Datum').value;
    if(this.Item.ID == -1 && podvrstaid  && datum)
      this.baseDataService.GetData('resenjezaplacenoodsustvo','KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
      .subscribe(data => {
        this.baseFormGroup.patchValue({BrojDokumenta: data});
        this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
      })

  }

  // U Initu je rano da se disable-uje, nešto radi nešto ne,
  // a ubačeno u timeout da bi sačekao sledeći krug provere stanja
  ngAfterViewInit(){
    setTimeout(()=>{
      this.baseFormGroup.get("Dana").disable();
      this.baseFormGroup.get("DatumPocetkaRada").disable();
    }, 0)

  }


  IzracunajBrojDana(){
    const period:DateRange=this.baseFormGroup.get('Period').value;
    if (period && period.ToDate)
    {
      const d2: NgbDate =period.ToDate;
      if (d2)
      {
        const rd=new RadniDani();
        const d1: NgbDate = period.FromDate;

        const dana: number=rd.ngbDajBrojRadnihDana(d1, d2);
        this.baseFormGroup.patchValue({Dana: dana});
        this.baseFormGroup.get('Dana').updateValueAndValidity();

        const datumPocetka: NgbDate=rd.ngbDajSledeciRadniDan(d2);
        this.baseFormGroup.patchValue({DatumPocetkaRada: datumPocetka});
        this.baseFormGroup.get('DatumPocetkaRada').updateValueAndValidity();
      }
    }
  }


  // SaveItem(){
  //   let a=4;
  // }

  editMode: boolean = false;
  item: any;
  PrintKnj(item1){}
  SaveMaster(qq){}
  onDatumChange(value){
    if(value!=null){
      let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
      this.TransferParameters = this.TransferParameters.set(0, parameterList);
      this.getBrojDokumenta();
      this.IzracunajBrojDana();
    }
  }
}
